import {
  Button,
  HStack,
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import {
  useInfiniteHits,
} from "react-instantsearch";
import { AlgoliaAttendeeObject } from "@common/interfaces/Algolia";
import { KYDTicketType } from "@common/interfaces/KYDTicket";

const AttendeesTable = ({
  ticket_types = [],
  onClickRefund,
  onEditAttendee,
  refreshingObjectIds,
  readOnly = false,
}: {
  readOnly?: boolean;
  ticket_types?: KYDTicketType[];
  onClickRefund: (attendee: AlgoliaAttendeeObject) => Promise<void>;
  onEditAttendee: (attendee: AlgoliaAttendeeObject) => Promise<void>;
  refreshingObjectIds: Record<string, boolean>;
}) => {
  const { items, showMore, isLastPage, results } =
    useInfiniteHits<AlgoliaAttendeeObject>({
      escapeHTML: false,
      showPrevious: false,
    });

  const findTicketTypeNameById = (ticketTypeId: string) => {
    const ticketType = ticket_types.find((t) => t.id === ticketTypeId);

    if (!ticketType) {
      // console.log(ticketTypeId, ticket_types);
      return "";
    }

    return ticketType.name;
  };

  const getUniqueTicketTypes = (
    ticket_type_ids: AlgoliaAttendeeObject["ticket_type_ids"]
  ) => {
    return Array.from(ticket_type_ids || []);
  };

  return (
    <Table w="full">
      <Thead>
        <Tr>
          <Th width={"20%"}>Name</Th>
          <Th width={"30%"}>Email</Th>
          <Th>Tickets</Th>
          <Th>Ticket types</Th>
          {!readOnly ? <Th></Th> : null}
        </Tr>
      </Thead>
      <Tbody>
        {items.map((attendee) => (
          <Tr key={attendee.id}>
            <Td
              cursor={"pointer"}
              onClick={() => onEditAttendee(attendee)}
              width="20%"
            >
              {attendee.first_name} {attendee.last_name}
            </Td>
            <Td
              cursor={"pointer"}
              onClick={() => onEditAttendee(attendee)}
              width="30%"
            >
              {attendee.email}
            </Td>
            <Td>{attendee.tickets_count}</Td>
            <Td>
              {getUniqueTicketTypes(attendee.ticket_type_ids)
                .map((t) => findTicketTypeNameById(t))
                .join(", ")}
            </Td>
            {!readOnly ? (
              <Td textAlign="right">
                <HStack width="full" justifyContent={"flex-end"}>
                  <Button
                    isDisabled={refreshingObjectIds[attendee.objectID]}
                    isLoading={refreshingObjectIds[attendee.objectID]}
                    onClick={() => onClickRefund(attendee)}
                  >
                    Refund
                  </Button>
                </HStack>
              </Td>
            ) : null}
          </Tr>
        ))}

        {items.length === 0 ? (
          <Tr>
            <Td colSpan={4}>
              <span>No attendees found</span>
            </Td>
          </Tr>
        ) : null}
      </Tbody>
    </Table>
  );
};

export default AttendeesTable;
